import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    AlertProps,
    Text
  } from '@chakra-ui/react'

interface CustomAlertProps extends AlertProps {
    title?: string
    status: "info" | "warning" | "success" | "error"
    message: string
    children?: JSX.Element
}

export function CustomAlert(props: CustomAlertProps) {
    const { title, status, message, children, ...rest } = props
    return (
        <Alert status={status} {...rest}>
            <AlertIcon/>
            {title && <AlertTitle>{title}</AlertTitle>}
            <AlertDescription>
                <Text>{message}</Text>
                {children}
            </AlertDescription>
        </Alert>
    )
}
